// For all available props, go https://react-slick.neostack.com/docs/api/

import React from 'react';
import Button from 'components/button';

const defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  allowDotsClick: true,
  arrows: true,
  arrowsFill: false,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: '50px',
  className: '',
  cssEase: 'ease',
  customPaging: onClick => <Button onClick={onClick} />,
  customPagingNoClick: onClick => <Button onClick={onClick} />,
  dots: false,
  dotsClass: 'slick-dots',
  draggable: false,
  // easing: 'linear',
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  serverRendered: false,
  slide: 'div',
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

export default defaultProps;
